/**
 * Role-based access control hook
 * Note: Super users are organization-scoped, not global admins
 */

import { useAuth } from '../contexts/AuthContext';
import { getUserTimezone } from '../utils/timezoneUtils';

export const useRBAC = () => {
  const { user, isSuperUser, isAuthenticated } = useAuth();
  const userTimezone = getUserTimezone();

  return {
    user,
    isAuthenticated,
    isSuperUser,
    isRegularUser: isAuthenticated && !isSuperUser,
    isExternalUser: user?.isExternalUser === true,
    rootOrganisationId: user?.rootOrganisationId,
    rootOrganisationName: user?.rootOrganisationName,
    organisationId: user?.organisationId,
    timezone: userTimezone,  // User's detected timezone
    canAccessSystemMonitoring: isSuperUser,
    canViewAllOrganisationData: false,
    isSameRootOrganisation: (resourceRootOrgId?: string) => {
      if (!user?.rootOrganisationId || !resourceRootOrgId) return false;
      return user.rootOrganisationId === resourceRootOrgId;
    },
  };
};

export default useRBAC;
